import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Eject.svg",
  "use": "Eject.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Eject.svg\"><path d=\"M54.01,44.0209a2,2,0,0,1-2,2h-40a2,2,0,0,1-2-2v-4a2,2,0,0,1,2-2h40a2,2,0,0,1,2,2Zm-.1463-11.2344a2.0007,2.0007,0,0,1-1.8483,1.2344H12.0033a2,2,0,0,1-1.4146-3.4143l20.0063-20a2,2,0,0,1,2.8292,0l20.0063,20A1.9993,1.9993,0,0,1,53.8642,32.7865Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol